import React, { useCallback, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { PrimaryLayout, relaxRequiredForProfileDefaults } from '../Layout';

function PrimaryTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const isSaved = props?.formFields?.ROWID && props.formFields.ROWID !== "00000000-0000-0000-0000-000000000000";

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        if (!props.formRefs?.current?.[name]) return;
        const ref = props.formRefs.current[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);

        const currentValue = props.formFields?.[name];
        if (currentValue !== undefined) {
            ref.instance().option('value', currentValue);
        }
    }, [props.formRefs, props.formFields]);

    const finalLayout = useMemo(() => {
        // Make Record # read-only once the record has been saved
        const layout = PrimaryLayout.map(group => ({
            ...group,
            fields: group.fields.map(field => (
                field.name === "RECORD"
                    ? { ...field, readOnly: !!isSaved }
                    : field
            ))
        }));

        // The profile template has no required fields at all - see the helper's note.
        return props.isProfileDefaults ? relaxRequiredForProfileDefaults(layout) : layout;
    }, [isSaved, props.isProfileDefaults]);

    const handlePrimaryFormLoad = useCallback(() => {
        const chargeTypes = [
            { id: 'I', text: 'Item Charge' },
            { id: 'T', text: 'Transaction Charge' },
            { id: 'S', text: 'Storage Charge' },
            { id: 'M', text: 'Miscellaneous Charge' },
        ];

        // Use setTimeout to ensure formRefs are available after FormField renders
        setTimeout(() => {
            loadLookupClient("CHARGETYPE", chargeTypes);

            // The parent owns formRefs, so it owns the enable/disable rules for Record # and
            // Profile - same split as itemDataEntry, whose PrimaryTab calls up to
            // primaryFormLookupsLoad in exactly this way.
            if (props.primaryFormLookupsLoad) props.primaryFormLookupsLoad();
        }, 100);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadLookupClient]);

    // Load ChargeType dropdown when formRefs become available
    useEffect(() => {
        const chargeTypes = [
            { id: 'I', text: 'Item Charge' },
            { id: 'T', text: 'Transaction Charge' },
            { id: 'S', text: 'Storage Charge' },
            { id: 'F', text: 'Freight Charge' },
            { id: 'H', text: 'Handling Charge' },
            { id: 'A', text: 'Accessorial Charge' },
            { id: 'O', text: 'Other Charge' }
        ];

        loadLookupClient("CHARGETYPE", chargeTypes);
    }, [loadLookupClient, props.formFields?.CHARGETYPE]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='3DA90CDE-B3B2-4C36-9966-C5C49E157184'
                layoutName='WMChargeCodePrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(PrimaryTab);

